import HubSession from './HubSession';
import { NotificationResult, INotification } from '@/types';
import { getCMConnectionManager } from './connections';

type ReceiveNotificationsHandler = (data: NotificationResult) => void;

type EventHandler = ReceiveNotificationsHandler;

export class NotificationsSession extends HubSession {
    // _dispatch: any;

    // constructor() {
    //     connectionManagerInstance.on('ReceiveNotifications', this.handleReceiveNotifications);
    // }

    constructor() {
        super(getCMConnectionManager());
    }

    markAsViewed(notifications: INotification[]) {
        this.connection.invoke(
            'MarkNotificationsAsViewed',
            notifications.map((x) => x.id)
        );
    }

    markAsClicked(notification: INotification) {
        this.connection.invoke('MarkNotificationAsClicked', notification.id);
    }
    requestNotifications(offset: number) {
        this.connection.invoke('RequestNotifications', offset);
    }

    // handleReceiveNotifications = (data: INotification[]) => {
    //     this._dispatch(addNotifications(data));
    // };

    protected addHandler(method: 'ReceiveNotifications', handler: ReceiveNotificationsHandler): void;
    protected addHandler(method: string, handler: EventHandler): void {
        super.addHandler(method, handler);
    }

    addOnReceiveNotifications(handler: ReceiveNotificationsHandler) {
        this.addHandler('ReceiveNotifications', (data) => {
            handler(data);
        });
    }

    // connect() {
    //     connectionManagerInstance.connect();
    // }

    // dispose() {
    //     connectionManagerInstance.off('ReceiveNotifications', this.handleReceiveNotifications);
    // }
}